(exports.GAME_ID = "5fe1a79e2898fd0017e161ea"),
(exports.FORM_ID = "5fe1a7d12898fd0017e161eb"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-dev");